import { render, staticRenderFns } from "./ConfirmationSummaryContacts.vue?vue&type=template&id=70642212&"
import script from "./ConfirmationSummaryContacts.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSummaryContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports